import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/** Facebook Feed on mobile ("Mobilne Novosti"). */
@Component({
  selector: 'app-meta-facebook-feed-mobile',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-feed-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../../preview-common/facebook/facebook-feed-styles.scss']
})
export class MetaFacebookFeedMobilePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** The mobile feed shows the first paragraph, up to Meta's 125 recommended characters. */
  get primaryText(): TruncatedCopy {
    return MetaPreviewCopy.firstParagraph(MetaPreviewCopy.primaryText(this.data), 125);
  }

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
